module.exports = __webpack_public_path__ + "static/media/teIInfo.4d4c59c4.png";